import React from "react";

const UnauthorizedPage = () => {
  const handleLogout = () => {
    // Clear authentication data from localStorage
    localStorage.removeItem("authToken");
    localStorage.removeItem("isAuthenticated");
    // Redirect to the login page
    window.location.href = "/login";
  };

  return (
    <div
      className="flex justify-center items-center min-h-screen"

    >
      <div className="bg-white p-8 rounded shadow-md w-96 text-center">
        <h1 className="text-3xl font-bold mb-6">Welcome to the Unauthorized Page!</h1>
        <p className="text-lg mb-4">You are logged in successfully.</p>
        <button
          onClick={handleLogout}
          className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
